module.exports = __webpack_public_path__ + "img/common-modal-icon.4d56a81b.svg";